import { type nft } from '#types/loreTypes'
import generateRootMeta from './rootMeta'

const generateNFTProfileMeta = ({
	origin = 'https://atomiclore.io',
	path,
	nft,
}: {
	origin?: string
	path: string
	nft?: nft
}) => {
	if (nft) {
		try {
			let chain
			let contractAddress
			let tokenId
			let queryParams = ''
			const splitParams = path.split('/').slice(1)
			if (splitParams.length >= 3) {
				chain = splitParams[1]
				if (chain == 'solana') {
					tokenId = splitParams[2]
					queryParams = `?chain=${chain}&tokenId=${tokenId}`
				} else {
					contractAddress = splitParams[2]
					tokenId = splitParams[3]
					queryParams = `?chain=${chain}&contractAddress=${contractAddress}&tokenId=${tokenId}`
				}
			}

			return [
				{
					title: nft
						? `Atomic Lore for ${nft.name}`
						: import.meta.env.VITE_APP_NAME
							? import.meta.env.VITE_APP_NAME
							: 'Atomic Lore',
				},
				{
					property: 'og:title',
					content: nft
						? `Atomic Lore for ${nft.name}`
						: import.meta.env.VITE_APP_NAME
							? import.meta.env.VITE_APP_NAME
							: 'Atomic Lore',
				},
				{ property: 'og:url', content: origin + path },
				{
					name: 'description',
					content: nft
						? `All the cryptographically signed stories and history for ${nft.name}, beautifully displayed`
						: import.meta.env.VITE_APP_DESCRIPTION
							? import.meta.env.VITE_APP_DESCRIPTION
							: 'A tool to explore NFT history, by Atomic Form',
				},
				{
					property: 'og:description',
					content: nft
						? `All the cryptographically signed stories and history for ${nft.name}, beautifully displayed`
						: import.meta.env.VITE_APP_DESCRIPTION
							? import.meta.env.VITE_APP_DESCRIPTION
							: 'A tool to explore NFT history, by Atomic Form',
				},
				{ property: 'og:site_name', content: 'atomiclore.io' },
				// IMAGE
				{ name: 'image', content: `${origin}/metadataImage${queryParams}` },
				{
					property: 'og:image',
					content: `${origin}/metadataImage${queryParams}`,
				},
				{ property: 'og:image:width', content: '1200px' },
				{ property: 'og:image:height', content: '630px' },
				// TWITTER / SLACK
				{
					name: 'twitter:image',
					content: `${origin}/metadataImage${queryParams}`,
				},
				{ name: 'twitter:card', content: 'summary_large_image' },
				{ name: 'twitter:site', content: '@atomicform' },
				{ name: 'twitter:creator', content: '@atomicform' },
				{
					name: 'twitter:description',
					content: nft
						? `All the cryptographically signed stories and history for ${nft.name}, beautifully displayed`
						: import.meta.env.VITE_APP_DESCRIPTION
							? import.meta.env.VITE_APP_DESCRIPTION
							: 'A tool to explore NFT history, by Atomic Form',
				},
				{
					name: 'twitter:title',
					content: nft
						? `Atomic Lore for ${nft.name}`
						: import.meta.env.VITE_APP_NAME
							? import.meta.env.VITE_APP_NAME
							: 'Atomic Lore',
				},
			]
		} catch (e) {
			console.error('ERROR GENERATING NFT PROFILE META', e)
			const metaPayload = generateRootMeta({ path, origin })
			return metaPayload
		}
	} else {
		const metaPayload = generateRootMeta({ path, origin })
		return metaPayload
	}
}

export default generateNFTProfileMeta
